import styled from 'styled-components';

export const StyledTapDisplayCard = styled.div`
  ${({ theme }) => `
    background-color: ${theme.color.white};
    padding: ${theme.space[4]}px;
    border-top: solid 1px ${theme.color.border};
  `}
`;

export const StyledCardNumberRowWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: start;
  & button {
    padding: 0;
    min-width: auto;
    height: auto;
  }
`;

export const StyledCardInfoWrapper = styled.div`
  ${({ theme }) => `
    display: flex;
    flex-direction: column;
    margin-bottom: ${theme.space[2]}px;
  `}
`;
